import { useScrollReveal, animStyle } from '../../../hooks/useScrollReveal';

export default function AboutUs() {
  const { ref: headerRef, visible: headerVisible } = useScrollReveal(0.3);
  const { ref: leftRef, visible: leftVisible } = useScrollReveal(0.15);
  const { ref: rightRef, visible: rightVisible } = useScrollReveal(0.15);

  return (
    <section id="about" className="relative w-full" style={{ minHeight: '600px' }}>
      <div className="absolute inset-0">
        <img
          src="https://static.wixstatic.com/media/e1c78c_8f2c0255955849019724a67353839dad.jpg/v1/fill/w_1280,h_1080,al_c,q_85,enc_avif,quality_auto/e1c78c_8f2c0255955849019724a67353839dad.jpg"
          alt="about background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/70" />
      </div>

      <div className="relative z-10 w-full px-5 sm:px-8 md:px-20 py-14 md:py-20">
        {/* Section header */}
        <div ref={headerRef} className="mb-10 md:mb-12">
          <div
            style={{
              width: headerVisible ? '32px' : '0px',
              height: '2px',
              backgroundColor: '#fff',
              marginBottom: '24px',
              transition: 'width 0.7s ease-out 0ms',
            }}
          />
          <h2
            className="text-5xl md:text-6xl font-bold text-white tracking-widest font-['Montserrat']"
            style={animStyle(headerVisible, 'fromLeft', 150, 750)}
          >
            ABOUT US
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-12 max-w-6xl">
          {/* CEO Message */}
          <div ref={leftRef} style={animStyle(leftVisible, 'fromLeft', 100, 800)}>
            <h3 className="text-white text-base font-semibold mb-4 tracking-wider">
              【代表の挨拶】
            </h3>
            <div className="space-y-4 text-white/80 text-sm leading-loose">
              <p>
                私は古くはパソコン通信の時代から、また、インターネット黎明期の頃からIT業界へ携わり、PKG開発、システム開発、Webマーケティング等の経歴を経て、2008年からコミュニケーションを伴うWebサービスの企画・開発に携わってきました。インターネットが普及した全てを今まで見てきて、今現在のこの世の中は、人と人がつながるサービスが不可欠の時代になってきたと実感しております。
              </p>
              <p>
                これまでの私の経歴と実績から、少しでも多くのみなさまと知り合う事が出来て、今までの経験をみなさまの為に提供する事ができたら、この会社を作った意味があったと思えます。「Groove Gravity」という社名は、みなさまの事業へ"Grooveを生み出し、牽引していく立場"という意味で名付けました。どんな事業でも我々のチカラで引っ張っていく、そんな理想を持っています。そのためにもどんな些細な事でも、お気軽にみなさまからのご連絡をお待ちしております。たくさんのみなさまとのつながりが私の財産です。
              </p>
              <p className="text-white/90 pt-2">
                株式会社Groove Gravity<br />
                代表取締役社長<br />
                上梨 能寛（カミナシ ヨシノブ）
              </p>
            </div>
          </div>

          {/* Company Info */}
          <div ref={rightRef} style={animStyle(rightVisible, 'fromRight', 250, 800)}>
            <h3 className="text-white text-base font-semibold mb-4 tracking-wider">
              【会社情報】
            </h3>
            <dl className="text-white/80 text-sm leading-loose space-y-2">
              {[
                ['会社名：', '株式会社Groove Gravity'],
                ['英語名：', 'Groove Gravity, Inc.'],
                ['住所：', '〒150-0002 東京都渋谷区渋谷3-6-2 エクラート渋谷5F'],
                ['TEL：', '03-5324-2299'],
                ['FAX：', '03-6869-9467'],
                ['代表：', '代表取締役 上梨 能寛（カミナシ ヨシノブ）'],
                ['設立：', '2018年7月'],
                ['資本金：', '1,000,000円'],
              ].map(([label, value], i) => (
                <div
                  key={i}
                  className="flex flex-col sm:flex-row sm:gap-2"
                  style={animStyle(rightVisible, 'fromRight', 300 + i * 60, 600)}
                >
                  <dt className="text-white/60 whitespace-nowrap">{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
            <div
              className="mt-5"
              style={animStyle(rightVisible, 'fromRight', 800, 600)}
            >
              <a
                href="https://isms.jp/isms-pims/lst/ind/CR_PM_x0020_755924.html"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
              >
                <span>ISO27001（ISMS）及び ISO27701（PIMS）取得済み</span>
                <i className="ri-external-link-line text-white/50 text-xs" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
